<template>
  <div class="authnet-page">
    <header class="authnet-header">
      <img class="header-logo" :src="'/images/brand-assets/authnet-lp_logo.jpg'">
      <img class="header-image" :src="'/images/brand-assets/authnet-lp_header.jpg'">
    </header>

    <div class="row status">
      <div class="col-xs-3 status-left">
        <i v-if="!success" class="fa fa-exclamation-circle"></i>
        <i v-else class="fa fa-check-circle"></i>
      </div>
      <div class="col-xs-9 status-right">
        <h2 v-if="!success">Transaction declined</h2>
        <h2 v-else>Transaction approved</h2>
        <p v-if="!success">Your payment has been DECLINED. <br><br>Please contact SAXX Credit Team
          at 1-888-409-7299 ext. 1 or email us at ar@saxxunderwear.com for
          support to complete this payment. <br>We look forward to assisting you further.
          <br><br>-SAXX Credit Team</p>
        <p v-else>Thank you for your payment!<br><br>
          If you have any questions or concerns, please don't hesitate to contact
          us at 1-888-409-7299 ext. 1 or email us at ar@saxxunderwear.com.
          <br>Have a great day!<br><br>-SAXX Credit Team</p>
        <br>
        <br>
        <p><b>Transaction ID: {{this.query.trnId}}<br>
          Message ID: {{this.query.messageId}}<br>
          Message text: {{this.query.messageText}}<br>
          Transaction date: {{this.query.trnDate}} UTC</b></p>
      </div>
    </div>
  </div>
</template>

<script>
import {language} from '../../lang';

export default {
  name: "AuthorizeNetFeedback",
  props: {
    lang: {
      required: false,
      type: String,
      default: "en",
    },
    query: {
      required: true,
    }
  },
  created() {

  },
  computed: {
    language() {
      const lang = language(this.lang);
      return lang.creditDashboard;
    },
    success(){
      return this.query.trnApproved==="1";
    }
  },
};
</script>
